import { render, staticRenderFns } from "./myDci-order.vue?vue&type=template&id=04d32c69&"
import script from "./myDci-order.vue?vue&type=script&lang=js&"
export * from "./myDci-order.vue?vue&type=script&lang=js&"
import style0 from "./myDci-order.vue?vue&type=style&index=0&id=04d32c69&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports